import { render } from "./PreviewFacsimile.vue?vue&type=template&id=55673f88"
import script from "./PreviewFacsimile.vue?vue&type=script&lang=js"
export * from "./PreviewFacsimile.vue?vue&type=script&lang=js"

import "./PreviewFacsimile.vue?vue&type=style&index=0&id=55673f88&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__